// extracted by mini-css-extract-plugin
export default {"no-content":"risk-matrix-configuration__no-content--EyZ5a","noContent":"risk-matrix-configuration__no-content--EyZ5a"};